export const weekday = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat",];
export const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const getDateTime = date => date ? `${weekday[date.getDay()]}, ${date.getDate()} of ${months[date.getMonth()]}, ${date.getFullYear()}` : 'not set'

export const getDate = date => {
    let dt = date ? new Date(date._seconds * 1000) : new Date();
    return `${dt.getDay()}-${dt.getMonth() + 1 }-${dt.getFullYear()}`;
}